<script lang="ts">
    import type {PdfRenderedPage} from 'src/features/media-viewer/services/mv-pdf-render.service';
    import {onMount} from 'svelte';

    export let renderedPage: PdfRenderedPage;
    export let width: number;
    export let height: number;
    export let pageNumber: number;

    let wrapperElement: HTMLDivElement;

    onMount(() => {
        wrapperElement.appendChild(renderedPage.annotationsLayer);
        wrapperElement.appendChild(renderedPage.textLayer);
    });
</script>

<div id="mv-pdf-page-{pageNumber}"
     class="mv-pdf-page"
     style:--width="{width}px"
     style:--height="{height}px">

    <img class="page-img" alt="PDF page {pageNumber}" src="{renderedPage.imgSrc}"/>

    <div class="additional-layers-wrapper" bind:this={wrapperElement}></div>
</div>

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";

    .mv-pdf-page {
        position: relative;
        isolation: isolate;
        width: var(--width);
        height: var(--height);

        .page-img {
            width: 100%;
            height: 100%;
            min-width: 100%;
            min-height: 100%;
            border-radius: @border-radius-large;
            background-color: var(--viewer-bg);
            border: 1px solid var(--viewer-default-border);
        }

        .additional-layers-wrapper {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 1;
        }
    }
</style>